import { ResourceService } from '../../../http/resource/resource.service';
import { HttpClient } from '@angular/common/http';
import { TBCPortal } from './tbc-portal';
import { TBCPortalSerializer } from './tbc-portal.serializer';
import { environment } from '@env';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TBCPortalService extends ResourceService<TBCPortal> {
  constructor(httpClient: HttpClient, router: Router) {
    super(
      httpClient,
      `${environment.API}`,
      { endpoint: 'portal/totvs' , router},
      new TBCPortalSerializer());
  }

  getTbcDataByPortalId(portalId: string) {
    this.endpoint = `portal/totvs/${portalId}`;
    return this.readBasic();
  }

}
